export default {
  loading: 'Carregando...',
  processing: 'Processando...',
  yes: 'Sim',
  no: 'Não',
  cancel: 'Cancelar',
  ok: 'Ok',
  all: 'Todos',
};



// WEBPACK FOOTER //
// ./src/i18n/pt-BR/Global.js